"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Wrapper_1 = require("./Wrapper");
const use_debounce_1 = require("use-debounce");
const react_use_1 = require("react-use");
// import { ProsysEditor } from '../../../comps/ProsysEditor';
const OsmosysRichEditor_1 = require("../../../comps/OsmosysRichEditor");
const DEFAULT_HEIGHT = 120;
// export const OsmosysRichTextEditor = ({ value, onChange }: IInputProps) => {
//   return <ProsysEditor value={value} onChange={onChange} />;
// };
exports.BlockCanvasInput = (props) => {
    const { height = DEFAULT_HEIGHT, disabled, value, onChange, contentStr, usingRichContentEditor, } = props;
    const [inputVal, setInput] = react_1.useState('');
    const [debouncedOnChange, , callPendingOnChange] = use_debounce_1.useDebouncedCallback((newVal) => {
        if (!disabled) {
            onChange(newVal);
        }
    }, 400, {
        maxWait: 300,
    });
    react_1.useEffect(() => {
        debouncedOnChange(inputVal);
    }, [inputVal]);
    react_1.useEffect(() => {
        if (inputVal !== contentStr) {
            setInput(contentStr || '');
        }
    }, [contentStr]);
    react_use_1.useUnmount(() => {
        if (inputVal !== contentStr) {
            callPendingOnChange();
        }
    });
    const sharedProps = {
        className: 'form-control flex-grow-1 rounded-0 border-0 m-0',
        style: {
            minHeight: height,
        },
    };
    //   // eslint-disable-next-line no-constant-condition
    if (usingRichContentEditor) {
        return (react_1.default.createElement(Wrapper_1.BlockCanvasInputWrapper, null,
            react_1.default.createElement(OsmosysRichEditor_1.OsmosysRichEditor, { value: value, editable: !disabled, onChange: newVal => {
                    if (newVal === '<p></p>') {
                        setInput('');
                        return;
                    }
                    setInput(newVal);
                } })));
    }
    if (disabled) {
        return (react_1.default.createElement(Wrapper_1.BlockCanvasInputWrapper, null,
            react_1.default.createElement("textarea", Object.assign({ value: value, disabled: true }, sharedProps))));
    }
    return (react_1.default.createElement(Wrapper_1.BlockCanvasInputWrapper, null,
        react_1.default.createElement("textarea", Object.assign({ value: inputVal, onChange: ({ target: { value: newVal } }) => {
                setInput(newVal);
            } }, sharedProps))));
};
//# sourceMappingURL=Input.js.map